"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import classNames from "classnames";
import { useAnalytics } from "@travel/shared/data-access";
import { ThemedButton, rootButtonClassNames, } from "@travel/shared/theme/ui";
import styles from "./button.module.css";
export var Button = forwardRef(function Button(_a, ref) {
    var className = _a.className, innerClassName = _a.innerClassName, contentClassName = _a.contentClassName, _b = _a.type, type = _b === void 0 ? "button" : _b, children = _a.children, trackProp = _a.track, style = _a.style, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, rest = __rest(_a, ["className", "innerClassName", "contentClassName", "type", "children", "track", "style", "onClick", "onFocus", "onBlur"]);
    var track = useAnalytics().track;
    var _c = __read(useState(false), 2), isHoveringInside = _c[0], setIsHoveringInside = _c[1];
    return (_jsx("button", { type: type, className: classNames(styles["container"], rootButtonClassNames(rest), className), disabled: rest.disabled, onClick: onClick, onFocus: onFocus, onBlur: onBlur, children: _jsx(ThemedButton, __assign({}, rest, { className: innerClassName, innerClassName: contentClassName, children: children })) }));
    function handleOnClick(event) {
        if (trackProp === null || trackProp === void 0 ? void 0 : trackProp.name) {
            track("".concat(trackProp.name, ":click"), trackProp.data);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }
});
export default Button;
